// extracted by mini-css-extract-plugin
export default {"sections":"BorderedCard_sections__vbJi8"};